import React, { useMemo } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { object } from 'prop-types';
import styled from 'styled-components';
import CalendarIcon from '../../../img/calendar-icon.svg';
import { bodyMRegularBrownStyles } from '../../../styles/typography';

const EmbeddedEventTimeParagraph = styled.p`
  ${bodyMRegularBrownStyles}
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: inherit;
  }
`;

const EmbeddedEventTime = ({ blok }) => {
  const { content, customCssClass } = blok;
  const cssClass = useMemo(() => ['embedded-event-time', customCssClass].filter(Boolean).join(' '), [customCssClass]);

  return content ? (
    <EmbeddedEventTimeParagraph {...storyblokEditable(blok)} className={cssClass}>
      <span className="mr-4">
        <CalendarIcon />
      </span>
      <span className="text-gray-300">{content}</span>
    </EmbeddedEventTimeParagraph>
  ) : undefined;
};

EmbeddedEventTime.propTypes = {
  blok: object.isRequired,
};

export default EmbeddedEventTime;
